// Sample notification rows for the /leads-past-notifications demo/empty
// state. Shape mirrors the /past-notifications response (each row already
// has its event_type normalised via normaliseEventType in the page) so the
// list, filters and badges render unchanged. While these render,
// useDemoNetworkGuard keeps window.__demoMode on and nothing touches the
// backend.

const iso = (daysAgo, hour = 10, mins = 0) => {
  const d = new Date(Date.now() - daysAgo * 86400 * 1000);
  d.setHours(hour, mins, 0, 0);
  return d.toISOString();
};

const DEMO_PAST_NOTIFICATIONS = [
  {
    event_type: "property_analysis",
    email: "emma.thompson@gmail.com",
    address_text: "12 Bower Street, Manly NSW 2095",
    property_id: "demo-prop-1",
    agent_name: "Demo Agent",
    created_at: iso(0, 9, 14),
  },
  {
    event_type: "property_report_sent",
    email: "emma.thompson@gmail.com",
    address_text: "12 Bower Street, Manly NSW 2095",
    property_id: "demo-prop-1",
    agent_name: "Demo Agent",
    created_at: iso(0, 9, 16),
  },
  {
    event_type: "view_appraisal",
    email: "liam.oconnor@outlook.com",
    address_text: "7 Darley Road, Manly NSW 2095",
    agent_name: "Demo Agent",
    created_at: iso(0, 11, 32),
  },
  {
    event_type: "property_analysis",
    email: "sophia.chen@yahoo.com.au",
    address_text: "29 Addison Road, Manly NSW 2095",
    property_id: "demo-prop-3",
    agent_name: "Demo Agent",
    created_at: iso(1, 14, 8),
  },
  {
    event_type: "start_request_appraisal_review",
    email: "noah.williams@gmail.com",
    address_text: "3 Wentworth Street, Manly NSW 2095",
    agent_name: "Demo Agent",
    created_at: iso(1, 16, 47),
  },
  {
    event_type: "submit_request_appraisal_review",
    email: "noah.williams@gmail.com",
    address_text: "3 Wentworth Street, Manly NSW 2095",
    agent_name: "Demo Agent",
    created_at: iso(1, 16, 52),
  },
  {
    event_type: "property_report_sent",
    email: "olivia.martin@gmail.com",
    address_text: "44 Lauderdale Avenue, Fairlight NSW 2094",
    property_id: "demo-prop-5",
    agent_name: "Demo Agent",
    created_at: iso(2, 10, 22),
  },
  {
    event_type: "suburb_analysis",
    email: "olivia.martin@gmail.com",
    address_text: "Fairlight NSW 2094",
    agent_name: "Demo Agent",
    created_at: iso(2, 19, 5),
  },
  {
    event_type: "save_notification_settings",
    email: "jack.robinson@icloud.com",
    address_text: "16 Sydney Road, Fairlight NSW 2094",
    agent_name: "Demo Agent",
    created_at: iso(3, 8, 41),
  },
  {
    event_type: "start_enquiry_form",
    email: "charlotte.lee@gmail.com",
    address_text: "8 Lewis Street, Fairlight NSW 2094",
    agent_name: "Demo Agent",
    created_at: iso(3, 13, 28),
  },
  {
    event_type: "property_analysis",
    email: "harper.singh@outlook.com",
    address_text: "22 Pittwater Road, Manly NSW 2095",
    property_id: "demo-prop-11",
    agent_name: "Demo Agent",
    created_at: iso(4, 12, 15),
  },
  {
    event_type: "property_report_request",
    email: "harper.singh@outlook.com",
    address_text: "22 Pittwater Road, Manly NSW 2095",
    agent_name: "Demo Agent",
    created_at: iso(4, 12, 20),
  },
  {
    event_type: "onboarding_complete",
    email: "isla.murphy@gmail.com",
    address_text: "5 Eurobin Avenue, Manly NSW 2095",
    agent_name: "Demo Agent",
    created_at: iso(5, 9, 3),
  },
  {
    event_type: "request_sign_in_code",
    email: "ethan.brown@hotmail.com",
    address_text: null,
    agent_name: "Demo Agent",
    created_at: iso(6, 18, 49),
  },
  {
    event_type: "view_appraisal",
    email: "mia.davies@gmail.com",
    address_text: "18 Eurobin Avenue, Manly NSW 2095",
    agent_name: "Demo Agent",
    created_at: iso(7, 11, 12),
  },
  {
    event_type: "property_analysis",
    email: "mia.davies@gmail.com",
    address_text: "18 Eurobin Avenue, Manly NSW 2095",
    property_id: "demo-prop-15",
    agent_name: "Demo Agent",
    created_at: iso(8, 15, 38),
  },
  {
    event_type: "suburb_profile_view",
    email: "lucas.taylor@gmail.com",
    address_text: "Balgowlah NSW 2093",
    agent_name: "Demo Agent",
    created_at: iso(9, 10, 4),
  },
  {
    event_type: "property_report_sent",
    email: "ava.wilson@outlook.com",
    address_text: "11 The Crescent, Fairlight NSW 2094",
    property_id: "demo-prop-18",
    agent_name: "Demo Agent",
    created_at: iso(11, 8, 56),
  },
];

export default DEMO_PAST_NOTIFICATIONS;
